<template>
    <v-dialog :value="value" @input="$emit('input', $event)" width="350">
        <v-sheet class="pa-4" color="surface">
            <div class="text-center mb-3">Do Navigator</div>
            <v-autocomplete
                class="mb-2"
                label="What to you want to do?"
                :items="items"
                outlined
                dense
                @input="handleInput"
                v-model="to"
                hide-details
                >
            </v-autocomplete>
        </v-sheet>
    </v-dialog>
</template>

<script>
export default {
    name: "QuickNavDialog",
    props: {
        value: Boolean
    },
    data() {
        return {
            to: null,
            items: [
                { text: "Inventory / Item Master Data", value: "/warehouse/item" },
                { text: "Inventory / Goods Receipt", value: "/warehouse/receipt" },
                { text: "Inventory / Goods Issue", value: "/warehouse/issue" },
                { text: "Inventory / Settings / Measure Units", value: "/warehouse/measure-unit" },
                { text: "Inventory / Settings / Warehouses", value: "/warehouse/warehouse" },
                { text: "Inventory / Settings / Item Groups", value: "/warehouse/item-group" },
                { text: "Inventory / Reports / Stock Movement", value: "/warehouse/stock-movement" },
                { text: "Inventory / Reports / Stock On Hand (Item)", value: "/warehouse/stock-on-hand-item" },
                { text: "Inventory / Reports / Stock On Hand (Warehouse)", value: "/warehouse/stock-on-hand-warehouse" },
                { text: "Purchase / Invoice", value: "/purchase/invoice" }
            ]
        }
    },
    watch: {
        
    },
    methods: {
        handleInput() {
            this.$router.push({path: this.to});
            this.to = null;
            this.$emit("input", false);
        },

    }
}
</script>

<style>

</style>